document.addEventListener('DOMContentLoaded', function () {

    var splide = new Splide('#SliderBanner', {
        type: 'fade',
        rewind: true,
        autoplay: true,
        interval: 5000,
        speed: 500,
        pagination: false,
        arrows: true,
        pauseOnHover: false,
        pauseOnFocus: false,
    });

    function animateContent(slideIndex) {

        // Remove animation classes globally
        document.querySelectorAll('.SliderBannerSlideContent').forEach(function (el) {
            el.classList.remove('animate__animated', 'animate__fadeInRight');
        });

        document.querySelectorAll('.SliderBannerSlideContentInner').forEach(function (el) {
            el.classList.remove('animate__animated', 'animate__fadeInUp');
        });

        // Get the CURRENT slide using the Splide API
        var slides = document.querySelectorAll('#SliderBanner .splide__slide');
        var activeSlide = slides[slideIndex];

        if (!activeSlide) return;

        var content = activeSlide.querySelector('.SliderBannerSlideContent');
        var inner = activeSlide.querySelector('.SliderBannerSlideContentInner');

        if (!content || !inner) return;

        // STEP 1
        content.classList.add('animate__animated', 'animate__fadeInRight');

        // STEP 2
        setTimeout(function () {
            inner.classList.add('animate__animated', 'animate__fadeInUp');
        }, 1000);
    }


    // 🔥 Remove FirstSlideDelay after the first slide moves
    let firstSlideHasMoved = false;

    splide.on('move', function (newIndex) {

        if (!firstSlideHasMoved) {
            document.querySelectorAll('.FirstSlideDelay').forEach(el => {
                el.classList.remove('FirstSlideDelay');
            });

            firstSlideHasMoved = true;
        }

        // Run animation sequence
        animateContent(newIndex);
    });

    splide.mount();
});